import { render, staticRenderFns } from "./modal-task.vue?vue&type=template&id=870af17e&"
import script from "./modal-task.vue?vue&type=script&lang=js&"
export * from "./modal-task.vue?vue&type=script&lang=js&"
import style0 from "./modal-task.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports